<template>
  <div class="left_menu">
    <header>
      <div
        v-for="item in roleBtnList"
        :class="type === item?'selects':'unselect'"
        :style="{width:roleBtnList.length > 1?'50%':'100%'}"
        :key="item"
        @click="changeType(item)"
      >{{item === 1?'教练员':item === 2?'运动员':'裁判员'}}</div>
    </header>
    <main>
      <el-col :span="24">
        <el-menu
          unique-opened
          background-color="#fff"
          active-text-color="#fff"
          text-color="#333"
          :default-active="$route.path"
          router
        >
          <template v-for="(item,index) in getMenu">
            <template v-if="item.children">
              <el-submenu
                v-if="getRegisterMenu(item.roleList)"
                :key="index + '-'"
                :index="item.path"
              >
                <template slot="title">
                  <i
                    class="icon iconfont"
                    :class="item.icon"
                    style="font-size:20px;margin-right:10px;color:#1E63B0"
                  ></i>
                  <span>{{item.title}}</span>
                </template>
                <el-menu-item
                  v-for="(temp,num) in item.children"
                  :key="index + '-' + num"
                  :index="item.path + temp.path"
                >{{temp.title}}</el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item v-if="getRegisterMenu(item.roleList)" :index="item.path" :key="index">
                <i
                  class="icon iconfont"
                  :class="item.icon"
                  style="font-size:20px;margin-right:10px;color:#1E63B0"
                ></i>
                <span slot="title">{{item.title}}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </el-col>
    </main>
  </div>
</template>
<script>
import menuList from "@/assets/json/router.json";
import { setSession, getSession } from "@/utils/storage";
export default {
  data() {
    return {
      type: 0,
      userInfo: {},
      currentRouter: null
    };
  },
  computed: {
    // 更新图片地址
    imgAddress() {
      return data => {
        return require(`@/assets/img/menu/${data}.png`);
      };
    },
    // 获取角色菜单
    getMenu() {
      if (this.userInfo.type === 1) {
        this.currentRouter = menuList.superAdmin.router;
        return menuList.superAdmin.router;
      } else if (this.userInfo.type === 2) {
        this.currentRouter = menuList.schoolAuditor.router;
        return menuList.schoolAuditor.router;
      } else if (this.userInfo.type === 3) {
        this.currentRouter = menuList.branchAuditor.router;
        return menuList.branchAuditor.router;
      } else if (this.userInfo.type === 4) {
        let arr = [];
        menuList.register.router.filter(item => {
          if (this.userInfo.matce === "signUp") {
            if (item.isHide || item.isCommon) {
              arr.push(item);
            }
          } else {
            if (!item.isHide || item.isCommon) {
              arr.push(item);
            }
          }
        });

        this.currentRouter = arr;
        return arr;
      } else {
        this.currentRouter = menuList.otherAdmin.router;
        return menuList.otherAdmin.router;
      }
    },
    // 获取教练员/注册员 切换按钮
    roleBtnList() {
      if (this.userInfo.matce === "signUp") return [];
      return this.userInfo.levelList;
    },
    // 获取角色菜单（注册者 对应教练员与学生注册员 菜单不同）
    getRegisterMenu() {
      return data => {
        if (this.userInfo.matce === "signUp") return true;
        return data.includes(this.type);
      };
    }
  },
  methods: {
    // 教练员/运动员/裁判员 切换
    changeType(type) {
      this.type = type;
      this.userInfo.currentRole = type;
      setSession("userInfo", JSON.stringify(this.userInfo));
      if (this.userInfo.type === 4) {
        let url =
          type === 1
            ? "/coach-registration"
            : type === 2
            ? "/athletes-registration"
            : "/judge-registration";
        this.$router.push(url);
      } else {
        let arr = [];
        let result = false;
        this.currentRouter.map(item => {
          if (item.roleList.includes(this.type)) arr.push(item);
        });
        arr.filter(item => {
          if (this.$route.path.indexOf(item.path) >= 0) result = true;
        });
        if (result) location.reload();
        else {
          this.$router.push(arr[0].path + arr[0].children[0].path);
        }
      }
    },
    // 根据用户信息判断教练员/运动员 切换按钮
    getRole() {
      let userInfo = getSession("userInfo") || null;
      if (!userInfo) return;
      userInfo = JSON.parse(userInfo);
      this.userInfo = userInfo;
      this.type = userInfo.currentRole;
    }
  },
  mounted() {
    this.getRole();
  }
};
</script>
<style lang="less" scoped>
.left_menu {
  /deep/ .el-menu {
    border-right: none;
  }
  /deep/ .el-menu-item.is-active i {
    color: #fff !important;
  }
  /deep/ .el-menu-item {
    font-size: 16px;
    // padding-left:55px!important;
    &:focus {
      background-color: #1e63b0 !important;
      color: #fff !important;
      & i {
        color: #fff !important;
      }
    }
    &:hover {
      background-color: rgba(30, 99, 176, 0.4) !important ;
      color: #fff !important;
      & i {
        color: #fff !important;
      }
    }
  }
  /deep/ .el-submenu .el-menu-item {
    padding-left: 55px !important;
  }
  /deep/ .el-submenu__title {
    font-size: 16px;
  }
  /deep/ .el-menu-item.is-active {
    background-color: #1e63b0 !important;
  }
  /deep/ .el-submenu__icon-arrow {
    margin-top: -4px;
  }
  main {
    overflow: hidden;
  }
}
header {
  display: flex;
  margin-bottom: 20px;
  > div {
    text-align: center;
    line-height: 40px;
    cursor: pointer;
  }
  > .coach {
    width: 50%;
  }
  > .athletes {
    flex: 1;
  }
  > .selects {
    background: #1e63b0;
    color: #fff;
  }
  > .unselect {
    background: #fff;
    color: #333;
  }
}
</style>